export const DEFAULT_INDICATOR_KEY = 'ticker';
